import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { CREATE_EDIT_ADJUSTMENT_FORM_NAME } from 'Common/FormEnum';
import PreviewAdjustmentComponent from '../../components/createEditAdjustment/PreviewAdjustmentComponent';
import connect from 'react-redux/es/connect/connect';
import { AdjustmentEnum } from 'Common/FieldEnum';

class PreviewAdjustmentContainer extends Component {
  render() {
    return <PreviewAdjustmentComponent {...this.props} />;
  }
}

const selector = formValueSelector(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
const mapStateToProps = state => {
  return {
    adjustmentItemsInfo: selector(state, [AdjustmentEnum.AdjustmentItemsInfo]),
  };
};

PreviewAdjustmentContainer = reduxForm({
  form: CREATE_EDIT_ADJUSTMENT_FORM_NAME,
  destroyOnUnmount: false,
})(PreviewAdjustmentContainer);

export const PreviewAdjustment = connect(
  mapStateToProps,
  null
)(PreviewAdjustmentContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/containers/createEditAdjustment/PreviewAdjustment.js